import {
  DATA_INTER,
  EARNING_ITEM_DATA_RAW_INTER,
  EARNING_STATUS_VIEW,
} from './constant';
import { convertDateToListTimezone } from '../../lib/lang/service';

export const convert = (list: EARNING_ITEM_DATA_RAW_INTER[]): DATA_INTER => {
  const converedData = list.map((e) => {
    const convert = {
      ...e,
      createDate: convertDateToListTimezone(e.createDate),
      status: {
        value: e.status,
        label: EARNING_STATUS_VIEW[e.status],
      },
      event: {
        value: e.event.id,
        label: e.event.title,
      },
    };

    return convert;
  });

  return { list: converedData, isEmpty: list?.length < 1 };
};
